import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/containers/ProgramDetail/index.tsx");
